import { RootState } from 'src/store';

export const getAgentDocsState = (state: RootState) => state.agentDocs;

export const getAgentDocumentsState = (state: RootState) =>
  getAgentDocsState(state).documents;

export const getAgentDocsLoadingState = (state: RootState) =>
  getAgentDocsState(state).isLoadingDocuments;

export const getAgentDocsGeneratingByDocId = (state: RootState) =>
  getAgentDocsState(state).generatingByDocId;

export const getAgentDocsLinksByDocId = (state: RootState) =>
  getAgentDocsState(state).reportLinksByDocId;

export const getAgentDocsResponseMessageByDocId = (state: RootState) =>
  getAgentDocsState(state).responseMessageByDocId;

export const getAgentDocsMessage = (state: RootState) =>
  getAgentDocsState(state).docsMessage;
